<template>
    <a
        :href="
            localePath('/app') +
            '?utm_source=loyalty&utm_medium=website&utm_campaign=app_download&utm_content=top_banner'
        "
        class="h-7.5 flex justify-center items-center bg-off-black text-white text-sm"
        v-text="$t('loyalty.banner.text')"
    />
</template>

<script lang="ts" setup>
const localePath = useLocalePath();
</script>
